import React, { Component } from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import { spring, AnimatedSwitch } from 'react-router-transition';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { history } from './_helpers';
import { PrivateRoute } from './_components';
import { Sidebar } from './_components';

import {
  DashboardContainer,
  SigninContainer,
  CompanyCreationContainer,
  SignupContainer,
  ValidateContainer,
  ResetPasswordContainer,
  DomainContainer,
  ChannelsContainer,
  MomentumContainer,
  MomentumsList,
  MomentumBuilder,
  RegisterMomentumContainer,
  NotFound,
  MediaPanel,
  DcmListingContainer,
  DcmManagerContainer
} from './containers';
 
import 'react-datepicker/dist/react-datepicker.min.css';
import './_styles/root.scss';
import 'react-notifications/lib/notifications.css';

function mapStyles(styles) {
  return {
    opacity: styles.opacity
  }
}

function bounce(val) {
  return spring(val, {
    stiffness: 300,
    damping: 30
  })
}

const bounceTransition = {
  atEnter: {
    opacity: 0,
    scale: 100,
  },
  atLeave: {
    opacity: bounce(0),
    scale: -100,
  },
  atActive: {
    opacity: bounce(1),
    scale: 0,
  },
};

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showComponents: false,
      isPrivate: false,
      domainsLoaded: false
    }

    history.listen((location) => {
      if ( location.pathname === '/' || location.pathname === '/channels' || location.pathname === '/domains' || location.pathname === '/v1/momentums' || location.pathname === '/v1/momentum/create' || location.pathname === '/v2/momentums' || location.pathname === '/v2/momentum/create' || location.pathname === '/user/workspace' || location.pathname === '/user/settings'  || location.pathname === '/media' || location.pathname === '/dcm' || location.pathname === '/dcm/manager' || location.pathname === '/v2/campaigns' || location.pathname === '/v2/campaign/create') {
        return this.setState({isPrivate: true})
      }

      this.setState({isPrivate: false})
    })

    this.handleDomainsLoad = this.handleDomainsLoad.bind(this);
    this.reloadSidebarWhenCreatingDomain = this.reloadSidebarWhenCreatingDomain.bind(this);
  }

  componentDidMount() {
    if ( history.location.pathname === '/' || history.location.pathname === '/channels' || history.location.pathname === '/domains' || history.location.pathname === '/v1/momentums' || history.location.pathname === '/v2/momentum/create' || history.location.pathname === '/v1/momentum/create' || history.location.pathname === '/v2/momentums' || history.location.pathname === '/user/workspace' || history.location.pathname === '/user/profile' || history.location.pathname === '/user/settings'  || history.location.pathname === '/media' || history.location.pathname === '/dcm' || history.location.pathname === '/dcm/manager' || history.location.pathname === '/v2/campaigns' || history.location.pathname === '/v2/campaign/create') {
      return this.setState({isPrivate: true})
    }

    this.setState({isPrivate: false})
  }

  handleDomainsLoad(options) {
    let shouldReload = options.shouldReload;
    this.setState({domainsLoaded: shouldReload});
  }

  reloadSidebarWhenCreatingDomain() {
    var self = this;
    
    this.setState({isPrivate: false}, () => self.setState({isPrivate: true}));
  }

  render() {
    return (
      <div className="wrapper">
        <div id="content">
          <Router history={history}>
            <main>
              <ToastContainer autoClose={4000} draggablePercent={60} />
              
              {
                this.state.isPrivate ?
                  sessionStorage.getItem('cellit_userdata') ?
                    <div>
                      <Sidebar handleLoad={this.handleDomainsLoad} />
                      {/* <SidebarNew /> */}
                    </div>
                  : null
                : null
              }

              <Switch>
                <AnimatedSwitch
                  atEnter={bounceTransition.atEnter}
                  atLeave={bounceTransition.atLeave}
                  atActive={bounceTransition.atActive}
                  mapStyles={mapStyles}
                  className="route-wrapper"
                >
                  {/* Normal routes */}
                  {/* <Route exact path="/signup/company" component={CompanyCreationContainer} />
                  <Route exact path="/signup/user" component={SignupContainer} />
                  <Route exact path="/signup/validate" component={ValidateContainer} /> */}

                  {/* Non-private routes that need subdomain */}
                  <Route exact path="/signin"  component={SigninContainer} />
                  {/* <Route exact path="/recovery" component={ResetPasswordContainer} /> */}

                  {/* Private routes */}
                  <PrivateRoute exact name="Analytics" path="/" component={DashboardContainer} domainsLoaded={this.state.domainsLoaded}/>
                  <PrivateRoute exact name="Channels" path="/channels" component={ChannelsContainer} domainsLoaded={this.state.domainsLoaded}/>
                  <PrivateRoute exact name="Domains" path="/domains" component={DomainContainer} reloadSidebar={this.reloadSidebarWhenCreatingDomain} domainsLoaded={true} />
                  <PrivateRoute exact name="Dcm" path="/dcm" component={DcmListingContainer} domainsLoaded={this.state.domainsLoaded} />
                  <PrivateRoute exact name="Dcm" path="/dcm/manager" component={DcmManagerContainer} domainsLoaded={this.state.domainsLoaded} />
                  <PrivateRoute exact name="Media" path="/media" component={MediaPanel} domainsLoaded={this.state.domainsLoaded}/>

                  <PrivateRoute exact name="Momentums" path="/v1/momentums" component={RegisterMomentumContainer} domainsLoaded={this.state.domainsLoaded}/>
                  <PrivateRoute exact name="Momentums" path="/v1/momentum/create" component={MomentumContainer} domainsLoaded={this.state.domainsLoaded}/>

                  {/* Momentum v2 */}
                  <PrivateRoute exact name="Momentums" path="/v2/momentums" component={MomentumsList} domainsLoaded={this.state.domainsLoaded}/>
                  <PrivateRoute exact name="Momentums" path="/v2/momentum/create" component={MomentumBuilder} domainsLoaded={this.state.domainsLoaded}/>
                  <PrivateRoute exact name="Momentums" path="/v2/campaigns" component={MomentumsList} domainsLoaded={this.state.domainsLoaded}/>
                  <PrivateRoute exact name="Momentums" path="/v2/campaign/create" component={MomentumBuilder} domainsLoaded={this.state.domainsLoaded}/>

                  {/* Non-existant routes */}
                  <Route exact path="*" component={NotFound} />
                </AnimatedSwitch>
              </Switch>
            </main>
          </Router>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  return { alert };
}

const ConnectedApp = connect(mapStateToProps)(App);
export { ConnectedApp as App }
